import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { getSettlementList } from 'redux/actions/SettlementAction';
import Loader from 'components/loader/Loader';
import { abbreviateNumber } from 'utils/utils';
import PaymentTable from './PaymentTable';
import PaymentHistory from './PaymentHistory';
import { ChequeDetails, DemandDraftDetails, rtgsDetails, cashfreeDetails } from './PaymentData';
import companyImg from 'assets/images/OfficeBlue.svg';

function PaymentDetails() {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDisabled, setisDisabled] = useState(true);

  useEffect(() => {
    dispatch(getSettlementList({ id: state?.id }));
  }, []);

  const companyDetail = useSelector((state) => state?.getSettlementList?.settlementList?.data);

  // Trimmed: onboarding has stored a leading tab on at least one company name.
  const companyName = companyDetail?.body?.[0]?.companyName?.trim();

  const paymentLoader = useSelector((state) => state?.getSettlementList?.loading);

  const getFormDataForPaymentMode = (paymentMode) => {
    // Set formData based on the selected radio button
    switch (paymentMode) {
      case 'Cheque':
        return ChequeDetails;
      case 'DemandDraft':
        return DemandDraftDetails;
      case 'NEFT':
        return rtgsDetails;
      case 'RTGS/NEFT':
        return rtgsDetails;
      case 'Cashfree':
        return cashfreeDetails;
      default:
        // Never hand the form renderer null: an unknown mode (a new gateway,
        // a renamed enum value) must degrade to the generic UTR view, not
        // crash the page.
        return rtgsDetails;
    }
  };

  const companyDefaultValue = companyDetail?.body?.[0];
  const defaultValue = {
    // Gateway receipts carry no payee: show the paying company instead.
    payee: companyDefaultValue?.payeeName || companyDefaultValue?.companyName?.trim(),
    chooseDate: companyDefaultValue?.settledAt,
    bankName: companyDefaultValue?.bankname,
    amount: companyDefaultValue?.amountSettled,
    chequeNo: companyDefaultValue?.chequeNo,
    settlementImg: companyDefaultValue?.settlementImg,
    demandNo: companyDefaultValue?.ddNo,
    tds: companyDefaultValue?.tds || '0',
    remark: companyDefaultValue?.remark || 'NA',
    branchName: companyDefaultValue?.branchName,
    accountNo: companyDefaultValue?.accountNo,
    utrTransactionId: companyDefaultValue?.utrTransactionId,
    gatewayPaymentId: companyDefaultValue?.gatewayPaymentId,
    receiptTime: companyDefaultValue?.timeOfReceipt,
  };

  return (
    <div>
      {paymentLoader ? (
        <Loader />
      ) : (
        <>
          <Box className="alignStart">
            <ArrowBackIosRoundedIcon
              className="font24 colorGrey mb20"
              role="presentation"
              onClick={() => navigate(-1)}
            />
          </Box>
          <Typography variant="head3" className="fw600 alignItem mb10">
            {' '}
            <img src={companyImg} alt="company" className="width40 mr6" />
            {companyName}
          </Typography>
          <PaymentTable invoiceTableData={companyDetail} pageName={'paymentDetails'} />

          <Grid container className="bgLightPrimary height122 mtb30 p20 justifyBetween">
            <Grid item>
              <Typography variant="body2"> Payment Mode</Typography>
              <Typography variant="head3" className="colorPrimary fw600">
                {state?.paymentMode}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2"> Payable Amount</Typography>
              <Typography variant="head3" className="colorPrimary fw600">
                {'₹ ' + abbreviateNumber(companyDetail?.body?.[0]?.outstandingAmount)}
              </Typography>
            </Grid>
          </Grid>
          <div className="mtb30">
            <PaymentHistory
              formData={getFormDataForPaymentMode(state?.paymentMode)}
              paymentName={state?.paymentMode}
              disable={true}
              defaultValues={defaultValue}
              disabled={isDisabled}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default PaymentDetails;
